import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as md5 from 'md5';

import { API } from '../../shared/constants/app-service-constants';
import { UserInformation } from './account-settings.model';

@Injectable({
  providedIn: 'root',
})
export class AccountSettingsService {
  constructor(private http: HttpClient) {}

  updateUserSettingData(): Observable<UserInformation> {
    return this.http.get<UserInformation>(`${API.USER_SETTINGS_INFO}`);
  }

  updateUserInfo(params: any): Observable<any> {
    return this.http.post(`${API.UPDATE_USER_INFO}`, params);
  }

  changePassword(params): Observable<any> {
    return this.http.post(`${API.CHANGE_PASSWORD}`, { ...params });
  }

  updateUserNotification(pushNotificationEnabled): Observable<any> {
    return this.http.post(`${API.UPDATE_USER_NOTIFICATION}`, { pushNotificationEnabled });
  }

  saveToLocalStore(uuid: string): void {
    const hash = md5(uuid);
    if (uuid) {
      localStorage.setItem('uuid', hash);
    }
  }
}
